import React from "react";
import Icons from "../../../../Config/Images";
import Fonts from "../../../../Config/Fonts";
import Colors from "../../../../theme/Colors";
import { formatDate } from "../../../../Utils";
import { userStatus } from "../../../../Constants/AppConstants";

const UserTableBody = ({
  users,
  onViewUserDetails,
  handleShowDeleteModal,
  onEditUserDetails,
  onViewBtnShow,
  onEditBtnShow,
  onDeleteBtnShow,
}) => {
  return (
    <tbody>
      {users?.map((user, index) => (
        <tr key={index}>
        <td style={tableDataInputStyle}>
            {index + 1}
          </td>
          <td style={tableDataInputStyle}>
            {`${user?.user_first_name} ${user?.user_last_name}`}
          </td>
          <td style={tableDataInputStyle} >
            {user?.user_shop_name || "-"}
          </td>
          <td style={tableDataInputStyle} >
            {user?.user_state || "-"}
          </td>
          <td style={tableDataInputStyle} >
            {user?.user_city || "-"}
          </td>
          <td style={tableDataInputStyle} >
            {user?.user_mobile_number}
          </td>
          <td style={tableDataInputStyle} >
            {formatDate(user?.created_at_timestamp)}
          </td>
          <td style={tableDataInputStyle} >
            <div
              style={{
                padding: "5px 10px",
                color: userStatus[user?.user_status_id]?.color,
                textAlign: "center",
              }}
            >
              {userStatus[user?.user_status_id]?.label || "Unknown"}
            </div>
          </td>
          <td style={tableDataInputStyle} >
            {user?.user_wallet_balance || "Nil"}
          </td>
          <td style={tableDataInputStyle} >
            {formatDate(user?.user_last_seen_date) || "-"}
          </td>
          <td style={tableDataInputStyle} >
            {formatDate(user?.user_last_order_date)}
          </td>
          <td style={tableDataInputStyle} >
            {user?.user_total_order_value || "-"}
          </td>
          <td style={tableDataInputStyle} >
            {user?.user_total_order_count || "-"}
          </td>
          <td style={tableDataInputStyle}>
            {onViewBtnShow==false && (
              <img
                src={Icons.viewIcon}
                style={{ height: "15px", width: "16px", cursor: "pointer" }}
                onClick={() => onViewUserDetails(user)}
                alt="Preview Icon"
              />
            )}
            {onEditBtnShow==false && (
              <img
                src={Icons.editIcon}
                style={{
                  height: "15px",
                  width: "16px",
                  cursor: "pointer",
                  marginLeft: "15px",
                }}
                onClick={() => onEditUserDetails(user)}
                alt="Edit Icon"
              />
            )}
            {onDeleteBtnShow==false && (
              <img
                src={Icons.trashIcon}
                style={{
                  height: "15px",
                  width: "16px",
                  cursor: "pointer",
                  marginLeft: "15px",
                }}
                onClick={() => handleShowDeleteModal(user?.user_id)}
                alt="Delete Icon"
              />
            )}
          </td>
        </tr>
      ))}
    </tbody>
  );
};

const tableDataInputStyle = {
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  textAlign: "center",
  padding: "8px 10px",
  border: "1px solid #E6E6E6",
};

export default UserTableBody;
